import { signQualified } from '../../../api/esign';

const commonQesESignHandler = async (signatures: { [key: string]: string }) => {
  const signFiles = Object.keys(signatures).map((fileId) =>
    signQualified(fileId, signatures[fileId])
  );
  return Promise.all(signFiles);
};

export default commonQesESignHandler;
